module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAA00lEQVQokaWSMQrCMBRAn9JFQVAEV4UMIbdwcxFP4KIn8BIunTp0L3gDcXXwDg6lQ9XOLg6Ci6BEbPkUqy2+JcnPf/yf8GtxFD4ozw3oKm3sSr2CaFmmosURFwdgUyBdgZ3SZiuDUt4rbRZlyrt+MAHmToncvDgC1vnKGXEUnoC+CCVKm8F7P02DVT/M0vpHzvhLlm9OxN4D2uJ8+Saf38ILpY33KTmPbXsGGKXNsWrbNXlw/aBjRxAYAs0Cpwc0ZNspK2BctnImu35gK93T6fkJ8AQZ0ia61xfzGAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/specializations/leagueoflegends/ad.png
// module id = JoFL
// module chunks = 38